import { groupBy as groupByToObject } from 'lodash'

// Like lodash groupBy, but returns a Map instead of an object.
export const groupBy = <T>(list: T[], getKey: (item: T) => string): Map<string, T[]> =>
  new Map(Object.entries(groupByToObject(list, getKey)))
